import { offerDataSelector } from './offerDataSelector';
import { IState } from '../../store';
import { getParent } from '../../utils/offer_helpers';

export const selectParent = (state: IState) => {
  const offerData = offerDataSelector(state);

  return getParent(offerData);
};
